import { React } from '@digsup/core-ui';

const FormContext = React.createContext({});

export { FormContext };
